/** Date format for File Properties panel. */
export const FilePropertiesDateFormat = 'MMM d, y, h:mm a';
